module.exports = __webpack_public_path__ + "img/ece5ee3.png";